// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root_2mrRB","container":"Container_container_Mc-o3","header":"Container_header_VKKU4","body":"Container_body_15GWA","breadcrumbs":"Container_breadcrumbs_kURxA"};